"use client";

import { Box, Container, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import MenuContext from "@/context/MenuProvider";
import color from "@/style/theme/Color";
import ListItemFasilitas from "./ListItemFasilitas";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import { mainTentangKamiNavMenus } from "@/layout/Navbar/Side/Sub/SubTentangKami";

const SubTentangKami = () => {
  const { stateAppBar, setStateAppBar, setStateListItem } = useContext(MenuContext)!;

  const toggleSubAppBar = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setStateAppBar({ ...stateAppBar, [anchor]: open });
  };

  const closeSubAppBar = () => {
    setStateAppBar({
      subAppBarTentangKami: false,
      subAppBarKoleksi: false,
      subAppBarLayanan: false,
      subAppBarBantuan: false
    });
  };

  const toggleListItem = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setStateListItem((prevState) => ({
      ...prevState,
      [anchor]: open,
    }));
  };

  return <Box
    sx={{
      paddingTop: "1em",
      paddingBottom: "1em",
      width: "100%",
      backgroundColor: color.white_transparent,
      backdropFilter: "blur(10px)",
      position: "fixed",
      top: "64px",
      right: "0",
      left: "0",
      zIndex: "10"
    }}
    onMouseOver={toggleSubAppBar("subAppBarTentangKami", true)}
    onMouseOut={closeSubAppBar}
  >
    <Container maxWidth="lg">
      <Stack direction="row" spacing={12}>
        <Typography sx={{ width: "300px", marginTop: "10px" }}>
          Jelajahi berbagai informasi mengenai Perpustakaan Politeknik Statistika STIS.
        </Typography>

        <Stack direction="row" spacing={3}>
          <List>
            {mainTentangKamiNavMenus.map((menu, key) => (
              <ListItem key={key} disablePadding sx={{ width: "200px" }}>
                {menu.anchor ? <ListItemButton
                  onMouseOver={toggleListItem(menu.anchor, true)}
                  sx={{
                    borderBottom: "1px solid rgb(230,230,230)",
                    borderLeft: "1px solid rgb(230,230,230)"
                  }}
                >
                  <ListItemText primary={menu.title}/>
                  <Stack>
                    <KeyboardArrowRightOutlinedIcon/>
                  </Stack>
                </ListItemButton> : <ListItemButton
                  href={menu.path ?? '#'}
                  sx={{
                    borderBottom: "1px solid rgb(230,230,230)",
                    borderLeft: "1px solid rgb(230,230,230)"
                  }}
                >
                  <ListItemText primary={menu.title}/>
                </ListItemButton>
                }
              </ListItem>
            ))}
          </List>
          <ListItemFasilitas/>
        </Stack>
      </Stack>
    </Container>
  </Box>;
};

export default SubTentangKami;
